// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card {\n  margin: 0;\n  margin-bottom: 2px; }\n\n.card-body {\n  box-shadow: 0px 0px 5px 0px #ddd;\n  border-radius: 5px; }\n\n.period-btn {\n  text-decoration: unset;\n  border: 0.5px solid #eee;\n  color: #636363; }\n  .period-btn.day {\n    border-radius: 15px 0px 0px 15px; }\n  .period-btn.month {\n    border-radius: 0px 0px 0px 0px; }\n  .period-btn.year {\n    border-radius: 0px 15px 15px 0px; }\n  .period-btn.active {\n    color: #ffbc1e; }\n", ""]);
// Exports
module.exports = exports;
